import React from 'react'
import { RouteProps } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { selectors } from '../../../redux'
import AuthenticationPage from '../Authentication'

import CancelSuccess from './CancelSuccess'
import CancelSlot from './CancelSlot'

const CancelPage: React.FC<RouteProps> = () => {
  const visitor = useSelector(selectors.app.visitor)
  const deleteRegistration = useSelector(selectors.app.deleteRegistration)
  const hasCanceledSlot = deleteRegistration?.success ?? false

  if (!visitor) {
    return <AuthenticationPage />
  }

  if (hasCanceledSlot) {
    return <CancelSuccess />
  }

  return <CancelSlot />
}

export default CancelPage
